'use client'

import { memo, type ComponentType, type ReactNode } from 'react'
import { useReducedMotion } from 'framer-motion'
import { cn } from '@/lib/utils'

export type MarketingOrbitItem = {
  id: string
  label: string
  icon: ComponentType<{ className?: string }>
}

export type MarketingOrbitRingProps = {
  items: readonly MarketingOrbitItem[]
  children: ReactNode
  className?: string
}

/**
 * baby: Webflow spinner / circular-ticker ornaments: icons orbit the
 * hero stage slowly (landing/01, web3).
 */
export const MarketingOrbitRing = memo(function MarketingOrbitRing({
  items,
  children,
  className,
}: MarketingOrbitRingProps) {
  const reduced = Boolean(useReducedMotion())
  const count = Math.max(items.length, 1)

  return (
    <div className={cn('marketing-orbit relative mx-auto', className)}>
      <div
        className={cn('marketing-orbit-ring', !reduced && 'is-spinning')}
        aria-hidden
      >
        {items.map((item, index) => {
          const Icon = item.icon
          const angle = (360 / count) * index
          return (
            <span
              key={item.id}
              className="marketing-orbit-item"
              style={{ transform: `rotate(${angle}deg) translateY(-46%) rotate(-${angle}deg)` }}
              title={item.label}
            >
              <Icon className="h-3.5 w-3.5" />
            </span>
          )
        })}
      </div>
      <div className="relative z-[1]">{children}</div>
    </div>
  )
})
